<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('dailyCashAdvance.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('dailyCashAdvance.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <a-range-picker
              v-model="dateRange"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width: 200px"
              @change="fetchData()"
            />
          </div>
          <div class="d-flex ts-justify-end ts-space-x-3">
            <Tooltip
              :content="$t('dailyCashAdvance.search')"
              placement="top"
              transfer
              :max-width="width"
            >
              <Input
                search
                v-model="search"
                :placeholder="$t('dailyCashAdvance.search')"
                :style="width"
                @on-focus="() => (width = 'width: 500px')"
                @on-blur="() => (width = 'width: 300px')"
              />
            </Tooltip>
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('dailyCashAdvance.branch') }}</label>
                  <ts-branch-filter-v2
                    @filter="branchFilter"
                    class="ts-w-full"
                  ></ts-branch-filter-v2>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <Table
        :columns="columns"
        :data="groupResources"
        :span-method="handleSpan"
        row-key="index"
        size="small"
        :loading="loading"
        highlight-row
        stripe
        max-height="700"
      >
        <template slot-scope="{ row }" slot="branch">
          {{ row.branch ? row.branch.branch_name_en : 'N/A' }}
        </template>
        <template slot-scope="{ row }" slot="advance_by">
          {{ row.advance_by ? row.advance_by.employee_name_en : 'N/A' }}
        </template>
        <template slot-scope="{ row }" slot="advance_amount">
          <ts-display-currency
            :amount="row.input_advance_amount"
            :currency_id="row.input_currency_id"
          />
        </template>
        <template slot-scope="{ row }" slot="converted_advance_amount">
          <ts-display-currency
            :amount="row.advance_amount"
            :currency_id="row.currency_id"
          />
        </template>
        <template slot-scope="{ row }" slot="amount_used">
          <ts-display-currency
            :amount="row.amount_used"
            :currency_id="row.currency_id"
          />
        </template>
        <template slot-scope="{ row }" slot="amount_due">
          <ts-display-currency
            :amount="row.amount_due"
            :currency_id="row.currency_id"
          />
        </template>
        <template slot-scope="{ row }" slot="status">
          <span class="badge bg-secondary" v-if="row.advance_status == 0">
            {{ row.advance_status_name ? row.advance_status_name : 'N/A' }}
          </span>
          <span class="badge bg-info" v-if="row.advance_status == 1">
            {{ row.advance_status_name ? row.advance_status_name : 'N/A' }}
          </span>
          <span class="badge bg-success" v-if="row.advance_status == 2">
            {{ row.advance_status_name ? row.advance_status_name : 'N/A' }}
          </span>
          <span class="badge bg-danger" v-if="row.advance_status == 3">
            {{ row.advance_status_name ? row.advance_status_name : 'N/A' }}
          </span>
        </template>
        <template slot-scope="{ row }" slot="payment_method">
          <span>
            {{ row.payment_method ? row.payment_method.payment_method : 'N/A' }}
          </span>
          <br />
          <span v-if="row.payment_method_id != 1">
            <span> {{ row.bank ? row.bank.bank_name : '' }} : </span>
            <span>
              {{ row.account_name + ' (' + row.account_number + ')' }}
            </span>
          </span>
        </template>
        <template slot-scope="{ row }" slot="create_by">
          {{ row.create_by ? row.create_by.employee_name_en : 'N/A' }}
        </template>
        <template slot-scope="{ row }" slot="action">
          <!-- <a
            href="#"
            v-tooltip="$t('dailyCashAdvance.reprint')"
            class="text-red mr-2"
            @click.prevent="reprintReport(row)"
          >
            <i class="fas fa-file-pdf"></i>
          </a> -->
          <a
            v-if="row.advance_status == 0"
            href="#"
            v-tooltip="$t('edit')"
            class="text-primary mr-2"
            @click.prevent="edit(row)"
          >
            <i class="fas fa-edit"></i>
          </a>
          <a-popconfirm
            v-if="row.advance_status == 0"
            placement="leftTop"
            :title="$t('are_you_sure_to_delete')"
            :ok-text="$t('yes')"
            :cancel-text="$t('no')"
            @confirm="deleteRecord(row)"
          >
            <a href="#" :disabled="row._deleting">
              <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
              <i class="fa fa-trash text-red" v-else></i>
            </a>
          </a-popconfirm>
        </template>
      </Table>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-i-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-i-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('dailyCashAdvance.pageTitle')"
        centered
        width="40%"
        @cancel="clearEdit"
        :maskClosable="false"
        :zIndex="1020"
        :footer="null"
      >
        <from-action @cancel="clearEdit" @fetchData="fetchData" />
      </a-modal>
      <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
        <ts-preview-pdf v-model="waiting" :src="src" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'
import { Errors } from 'form-backend-validation'
import iTable from '@/store/i-table-helper'

export default {
  name: 'DailyCashAdvance',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false,
      waiting: false,
      show_pdf: false,
      src: '',
      errors: new Errors(),
      width: 'width: 300px',
      model: {
        deleted_reason: null
      }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('expense/dailyCashAdvance', ['resources', 'pagination']),
    groupResources() {
      return iTable.rowGroup(this.resources, 'advance_date')
    },
    search: {
      get() {
        return this.$store.state.expense.dailyCashAdvance.search
      },
      set(newValue) {
        this.$store.commit('expense/dailyCashAdvance/SET_SEARCH', newValue)
        this.$store.commit('expense/dailyCashAdvance/RESET_CURRENT_PAGE')
      }
    },
    dateRange: {
      get() {
        return this.$store.state.expense.dailyCashAdvance.dateRange
      },
      set(newValue) {
        this.$store.commit('expense/dailyCashAdvance/SET_DATE_RANGE', newValue)
      }
    },
    columns() {
      return [
        {
          key: 'column_name',
          tree: true,
          maxWidth: 15
        },
        {
          title: this.$t('dailyCashAdvance.branch'),
          slot: 'branch',
          width: 100,
          sortable: true
        },
        {
          title: this.$t('dailyCashAdvance.advanceNo'),
          key: 'advance_no',
          width: 130,
          sortable: true
        },
        {
          title: this.$t('dailyCashAdvance.purpose'),
          key: 'purpose',
          minWidth: 200,
          sortable: true,
          tooltip: true
        },
        {
          title: this.$t('dailyCashAdvance.advancedBy'),
          slot: 'advance_by',
          width: 140,
          sortable: true
        },
        {
          title: this.$t('dailyCashAdvance.advancedAmount'),
          slot: 'advance_amount',
          width: 170,
          sortable: true,
          align: 'right'
        },
        {
          title: this.$t('dailyCashAdvance.convertedAdvancedAmount'),
          slot: 'converted_advance_amount',
          width: 230,
          sortable: true,
          align: 'right'
        },
        {
          title: this.$t('dailyCashAdvance.amountUsed'),
          slot: 'amount_used',
          width: 170,
          sortable: true,
          align: 'right'
        },
        {
          title: this.$t('dailyCashAdvance.reimburseAmount'),
          slot: 'amount_due',
          width: 170,
          sortable: true,
          align: 'right'
        },
        {
          title: this.$t('dailyCashAdvance.status'),
          slot: 'status',
          width: 110,
          sortable: true,
          align: 'center'
        },
        {
          title: this.$t('dailyCashAdvance.paymentMethod'),
          slot: 'payment_method',
          width: 210,
          sortable: true,
          tooltip: true
        },
        {
          title: this.$t('dailyCashAdvance.vendorName'),
          key: 'vendor_name',
          width: 140,
          sortable: true
        },
        {
          title: this.$t('dailyCashAdvance.description'),
          key: 'description',
          width: 150,
          tooltip: true
        },
        {
          title: this.$t('dailyCashAdvance.createdBy'),
          slot: 'create_by',
          width: 150,
          sortable: true
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 94
        }
      ]
    }
  },
  methods: {
    handleSpan({ row, column, rowIndex, columnIndex }) {
      return iTable.handleSpan(row, columnIndex, this.columns)
    },
    displayConvert() {
      const fromAmount = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(41000)

      const toAmount = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(10)

      return `${'៛'} ${fromAmount}`
      // return `${'៛'} ${fromAmount} ≈ ${'$'} ${toAmount}`
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('expense/dailyCashAdvance/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('expense/dailyCashAdvance/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit() {
      this.$store.commit('expense/dailyCashAdvance/SET_EDIT_DATA', {})
      this.showForm = false
      this.fetchData()
    },
    deleteRecord(record) {
      this.model.deleted_reason = null
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.$store
            .dispatch('expense/dailyCashAdvance/destroy', {
              id: record.advance_id,
              data: this.model
            })
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    },
    branchFilter(value) {
      this.$store.commit('expense/dailyCashAdvance/SET_BRANCH_ID', value)
      this.fetchData()
    },
    reprintReport(record) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('expense/dailyCashAdvance/toPdf', record.advance_id)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('expense/dailyCashAdvance/RESET_STATE')
    next()
  }
}
</script>
<style>
.ivu-table-cell-tree {
  margin-right: 10px;
}
.ivu-table-small i {
  font-size: 14px;
}
</style>
